import React from 'react';
import PropTypes from 'prop-types';

import {PlayerMinimalPropType} from "../../../../utils/propTypes";

const PlayerComponent = ({player, selectPlayer, leftIcon}) => (
    <div className="players__player" key={player.id}>
        <div
            className="container"
            onClick={() => selectPlayer(player)}
        >
            <i className={`left-icon ${leftIcon}`} />
            {player.name}
        </div>
    </div>
);

PlayerComponent.propTypes = {
    player: PlayerMinimalPropType,
    selectPlayer: PropTypes.func.isRequired,
    leftIcon: PropTypes.string,
};


export default PlayerComponent;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/Player/PlayerComponent.js